import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { POSITION_STATE } from '../../consts/enums';
import STRING_KEYS from '../../language/keys';
import { POSITIONS_STATUS_MAP } from '../../consts';
import Status from '../Status';
import { PositionCloseStatus } from './PositionCloseStatus';

interface PositionStatus {
  state: string;
  closedAt: Date | string;
  closedByUserId: string,
  closureReason: string,
  closureReasonfreeText: string,
  isNew: boolean;
  status?: string | undefined;
}

const PositionStatus:FC<PositionStatus> = (props): JSX.Element => {
  const {
    state, closedAt, closedByUserId, closureReason, closureReasonfreeText, isNew, status,
  } = props;
  const { t: translate } = useTranslation();

  if (state === POSITION_STATE.CLOSED) {
    return (
      <PositionCloseStatus
        closedAt={ closedAt }
        closedByUserId={ closedByUserId }
        closureReason={ closureReason }
        closureReasonfreeText={ closureReasonfreeText }
      />
    );
  }

  return (
    <Status
      label={ !isNew && status ?
        translate(STRING_KEYS.POSITION_STATUSES[status]) :
        translate(STRING_KEYS.POSITION_STATUSES.INACTIVE) }
      type={ !isNew && status ?
        POSITIONS_STATUS_MAP[status]  :
        POSITIONS_STATUS_MAP.INACTIVE }
    />
  );
};

PositionStatus.defaultProps = {
  status: undefined,
};

export default PositionStatus;
